import { getContext, Symbols } from 'choerodon-ui/shared';
import { open } from '../modal-container/ModalContainer';
const ModalContext = getContext(Symbols.ModalContext, { open });
export default ModalContext;
